import React from 'react'
import { ArrowRightIcon } from 'lucide-react'

import { intlFormat } from '@/shared/tools/dates'

export const PricingCampaignPeriod = ({
	startDate,
	endDate,
}: {
	startDate?: string
	endDate?: string
}) => {
	if (!startDate && !endDate) {
		return '-'
	}

	return (
		<div className='flex items-center space-x-1 font-normal'>
			{startDate && <span>{intlFormat(new Date(startDate + 'Z'))}</span>}
			{(startDate || endDate) && <ArrowRightIcon className='size-4 shrink-0' />}
			{endDate && <span>{intlFormat(new Date(endDate + 'Z'))}</span>}
		</div>
	)
}
